import styled from 'styled-components'

export const Input = styled.input`
  background-color: #eeeeee;

  height: 50px;
  margin-block: 5px;

  border-radius: 8px;
  border-style: none;

  text-align: left;
  padding-left: 10px;

  font-family: 'Nunito', sans-serif;
  font-size: 13px;
  font-weight: 500;
`
